// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
  height: auto !important;
  min-height: auto !important;
}
@media (min-width: 1024px) {
  :host {
    height: 100% !important;
  }
}

ion-card {
  width: 100%;
  height: auto !important;
  min-height: auto !important;
  margin: 0;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
@media (min-width: 1024px) {
  ion-card {
    height: 100% !important;
  }
}

ion-card-header {
  height: 5vh;
  max-height: 5vh;
  min-height: 5vh;
  flex: 0 0 auto;
  padding: 0 !important;
  margin: 0 !important;
}

ion-card-content {
  height: auto;
  flex: 0 0 auto;
  padding: 0 !important;
  margin: 0;
  overflow: hidden;
  width: 100%;
}
@media (min-width: 1024px) {
  ion-card-content {
    flex: 1 !important;
    min-height: 0 !important;
  }
}

ion-chip {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.download-logbook-button {
  opacity: 1;
  position: absolute;
  z-index: 990;
  width: 18%;
  min-width: 15px !important;
  min-height: 15px !important;
  height: 80% !important;
  right: var(--spacing-large);
  border-radius: var(--af-radius-section);
  background-color: var(--ion-color-primary);
  border: 2px solid transparent !important;
  margin-left: auto;
  margin-right: var(--spacing-large);
  transition: all 0.3s ease;
  cursor: pointer;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-small);
}
@media (min-width: 1024px) {
  .download-logbook-button {
    width: auto;
    min-width: max-content;
    padding: 0 var(--spacing-medium);
  }
}
.download-logbook-button ion-icon {
  color: white !important;
  font-size: 16px;
}
.download-logbook-button ion-label {
  color: white !important;
  display: none;
  white-space: nowrap;
}
@media (min-width: 1024px) {
  .download-logbook-button ion-label {
    display: inline;
  }
}
.download-logbook-button:hover {
  border: 2px solid var(--ion-color-primary) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  color: var(--ion-color-primary);
  background-color: white;
}
.download-logbook-button:hover ion-icon,
.download-logbook-button:hover ion-label {
  color: var(--ion-color-primary) !important;
}
.download-logbook-button:active {
  transform: scale(0.98);
}

.card-header {
  height: 5vh;
  max-height: 5vh;
  min-height: 5vh;
  display: flex;
  align-items: center;
  padding: var(--spacing-large) var(--spacing-small);
  color: white !important;
  border-left: 5px solid var(--ion-color-primary);
  background: linear-gradient(90deg, color-mix(in srgb, var(--ion-color-primary) 12%, white), color-mix(in srgb, var(--ion-color-primary) 3%, white)) !important;
}

.pilot-table-title {
  color: var(--ion-color-primary) !important;
  font-weight: bold;
}

.header-content {
  display: flex;
  align-items: center;
  gap: var(--spacing-small);
  width: 100%;
}

.pilot-table-title {
  font-weight: bold;
  left: var(--spacing-small);
  width: auto;
  color: var(--ion-color-primary) !important;
}
@media (max-width: 599px) {
  .pilot-table-title {
    font-size: clamp(0.8rem, 1.5vw, 1rem);
  }
}

.table-content {
  padding: 0;
  height: auto;
  overflow: hidden;
}
@media (max-width: 1023px) {
  .table-content {
    height: 268px;
    min-height: 268px;
    max-height: 268px;
    overflow: visible;
  }
}
@media (min-width: 1024px) {
  .table-content {
    height: 100%;
    min-height: 0;
    max-height: none;
    overflow: auto;
  }
}

.table {
  height: auto;
  width: 100%;
  overflow: hidden;
}
@media (min-width: 1024px) {
  .table {
    height: 100%;
  }
}

/** Media queries to set font size and spacing based on screen size **/
/*#region Small Screens*/
/* Styles for screens smaller than 800px wide or 550 high */
@media (max-width: 800px) or (max-height: 550px) {
  .pilot-table-title {
    font-size: var(--font-size-large);
  }
  .table-chip-label {
    display: none;
  }
  .table-chip-icon {
    margin: 0;
    height: 80%;
    width: 80%;
  }
}
/*#endregion Small Screens*/
/*#region Medium Screens*/
/* Styles for medium screens with min with of 800px and min height of 550px */
@media (min-width: 800px) and (min-height: 550px) {
  .pilot-table-title {
    font-size: var(--font-size-large);
  }
}
/*#endregion Medium Screens*/
/*#region Larger Screens*/
/* Styles for screens larger than 1000px wide and 600px high */
@media (min-width: 1000px) and (min-height: 600px) {
  .pilot-table-title {
    font-size: var(--font-size-large);
  }
}
/*#endregion Larger Screens*/`, "",{"version":3,"sources":["webpack://./src/app/pages/logbooks/components/log-tables/pilot-table/pilot-table.component.scss","webpack://./src/theme/mocca-breakpoints.scss"],"names":[],"mappings":"AASA;EACI,cAAA;EACA,WAAA;EACA,uBAAA;EACA,2BAAA;AARJ;ACkCE;ED9BF;IAOQ,uBAAA;EAPN;AACF;;AAUA;EACI,WAAA;EACA,uBAAA;EACA,2BAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;AAPJ;ACkBE;EDnBF;IAWQ,uBAAA;EANN;AACF;;AASA;EACI,WAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;EACA,oBAAA;AANJ;;AASA;EACI,YAAA;EACA,cAAA;EACA,qBAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;AANJ;ACLE;EDKF;IASQ,kBAAA;IACA,wBAAA;EALN;AACF;;AAQA;EACI,wBAAA;EACA,kCAAA;EACA,8BAAA;AALJ;;AAQA;EACI,UAAA;EACA,kBAAA;EACA,YAAA;EAEA,UAAA;EACA,0BAAA;EACA,2BAAA;EACA,sBAAA;EAEA,2BAAA;EAEA,uCAAA;EACA,0CAAA;EACA,wCAAA;EAEA,iBAAA;EACA,kCAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AATJ;ACxCE;EDyBF;IA2BQ,WAAA;IACA,sBAAA;IACA,gCAAA;EARN;AACF;AAUI;EACI,uBAAA;EACA,eAAA;AARR;AAWI;EACI,uBAAA;EACA,aAAA;EACA,mBAAA;AATR;ACxDE;ED8DE;IAMQ,eAAA;EARV;AACF;AAWI;EACI,qDAAA;EACA,0CAAA;EACA,+BAAA;EACA,uBAAA;AATR;AAWQ;;EAEI,0CAAA;AATZ;AAaI;EACI,sBAAA;AAXR;;AAeA;EACI,WAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,kDAAA;EACA,uBAAA;EACA,+CAAA;EACA,8JAAA;AAZJ;;AAeA;EACI,0CAAA;EACA,iBAAA;AAZJ;;AAeA;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;AAZJ;;AAeA;EACI,iBAAA;EACA,0BAAA;EACA,WAAA;EACA,0CAAA;AAZJ;ACvHE;ED+HF;IAOQ,qCAAA;EAXN;AACF;;AAcA;EACI,UAAA;EACA,YAAA;EACA,gBAAA;AAXJ;ACtGE;ED8GF;IAMQ,aAlKkB;IAmKlB,iBAnKkB;IAoKlB,iBApKkB;IAqKlB,iBAAA;EAVN;AACF;AC5HE;ED4HF;IAaQ,YAAA;IACA,aAAA;IACA,gBAAA;IACA,cAAA;EATN;AACF;;AAYA;EACI,YAAA;EACA,WAAA;EACA,gBAAA;AATJ;AC1IE;EDgJF;IAMgB,YAAA;EARd;AACF;;AAWA,sEAAA;AAEA,wBAAA;AAEE,2DAAA;AACA;EAEE;IACI,iCAAA;EAXN;EAcE;IACI,aAAA;EAZN;EAeE;IACI,SAAA;IACA,WAAA;IACA,UAAA;EAbN;AACF;AAgBA,2BAAA;AAEA,yBAAA;AAEE,6EAAA;AACA;EAEE;IACI,iCAAA;EAjBN;AACF;AAqBA,4BAAA;AAEA,yBAAA;AAEE,8DAAA;AACA;EAEE;IACI,iCAAA;EAtBN;AACF;AA0BA,4BAAA","sourcesContent":["@use 'src/theme/mocca-breakpoints' as bp;\r\n\r\n$log-table-visible-rows: 5;\r\n$log-table-row-height: 36px;\r\n$log-table-header-height: 38px;\r\n$log-table-pagination-height: 38px;\r\n$log-table-horizontal-scroll-height: 12px;\r\n$log-table-mobile-height: ($log-table-visible-rows * $log-table-row-height) + $log-table-header-height + $log-table-pagination-height + $log-table-horizontal-scroll-height;\r\n\r\n:host {\r\n    display: block;\r\n    width: 100%;\r\n    height: auto !important;\r\n    min-height: auto !important;\r\n\r\n    @include bp.desktop {\r\n        height: 100% !important;\r\n    }\r\n}\r\n\r\nion-card {\r\n    width: 100%;\r\n    height: auto !important;\r\n    min-height: auto !important;\r\n    margin: 0;\r\n    overflow: hidden;\r\n    box-sizing: border-box;\r\n    display: flex;\r\n    flex-direction: column;\r\n\r\n    @include bp.desktop {\r\n        height: 100% !important;\r\n    }\r\n}\r\n\r\nion-card-header {\r\n    height: 5vh;\r\n    max-height: 5vh;\r\n    min-height: 5vh;\r\n    flex: 0 0 auto;\r\n    padding: 0 !important;\r\n    margin: 0 !important;\r\n}\r\n\r\nion-card-content {\r\n    height: auto;\r\n    flex: 0 0 auto;\r\n    padding: 0 !important;\r\n    margin: 0;\r\n    overflow: hidden;\r\n    width: 100%;\r\n\r\n    @include bp.desktop {\r\n        flex: 1 !important;\r\n        min-height: 0 !important;\r\n    }\r\n}\r\n\r\nion-chip {\r\n    display: flex !important;\r\n    justify-content: center !important;\r\n    align-items: center !important;\r\n}\r\n\r\n.download-logbook-button {\r\n    opacity: 1;\r\n    position: absolute;\r\n    z-index: 990;\r\n\r\n    width: 18%;\r\n    min-width: 15px !important;\r\n    min-height: 15px !important;\r\n    height: 80% !important;\r\n\r\n    right: var(--spacing-large);\r\n\r\n    border-radius: var(--af-radius-section);\r\n    background-color: var(--ion-color-primary);\r\n    border: 2px solid transparent !important;\r\n\r\n    margin-left: auto;\r\n    margin-right: var(--spacing-large);\r\n    transition: all 0.3s ease;\r\n    cursor: pointer;\r\n    color: white;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: var(--spacing-small);\r\n\r\n    @include bp.desktop {\r\n        width: auto;\r\n        min-width: max-content;\r\n        padding: 0 var(--spacing-medium);\r\n    }\r\n\r\n    ion-icon {\r\n        color: white !important;\r\n        font-size: 16px;\r\n    }\r\n\r\n    ion-label {\r\n        color: white !important;\r\n        display: none;\r\n        white-space: nowrap;\r\n\r\n        @include bp.desktop {\r\n            display: inline;\r\n        }\r\n    }\r\n\r\n    &:hover {\r\n        border: 2px solid var(--ion-color-primary) !important;\r\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n        color: var(--ion-color-primary);\r\n        background-color: white;\r\n\r\n        ion-icon,\r\n        ion-label {\r\n            color: var(--ion-color-primary) !important;\r\n        }\r\n    }\r\n\r\n    &:active {\r\n        transform: scale(0.98);\r\n    }\r\n}\r\n\r\n.card-header {\r\n    height: 5vh;\r\n    max-height: 5vh;\r\n    min-height: 5vh;\r\n    display: flex;\r\n    align-items: center;\r\n    padding: var(--spacing-large) var(--spacing-small);\r\n    color: white !important;\r\n    border-left: 5px solid var(--ion-color-primary);\r\n    background: linear-gradient(90deg, color-mix(in srgb, var(--ion-color-primary) 12%, white), color-mix(in srgb, var(--ion-color-primary) 3%, white)) !important;\r\n}\r\n\r\n.pilot-table-title {\r\n    color: var(--ion-color-primary) !important;\r\n    font-weight: bold;\r\n}\r\n\r\n.header-content {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: var(--spacing-small);\r\n    width: 100%;\r\n}\r\n\r\n.pilot-table-title {\r\n    font-weight: bold;\r\n    left: var(--spacing-small);\r\n    width: auto;\r\n    color: var(--ion-color-primary) !important;\r\n\r\n    @include bp.mobile {\r\n        font-size: clamp(0.8rem, 1.5vw, 1rem);\r\n    }\r\n}\r\n\r\n.table-content {\r\n    padding: 0;\r\n    height: auto;\r\n    overflow: hidden;\r\n\r\n    @include bp.desktop-down {\r\n        height: $log-table-mobile-height;\r\n        min-height: $log-table-mobile-height;\r\n        max-height: $log-table-mobile-height;\r\n        overflow: visible;\r\n    }\r\n\r\n    @include bp.desktop {\r\n        height: 100%;\r\n        min-height: 0;\r\n        max-height: none;\r\n        overflow: auto;\r\n    }\r\n}\r\n\r\n.table {\r\n    height: auto;\r\n    width: 100%;\r\n    overflow: hidden;\r\n\r\n        @include bp.desktop {\r\n                height: 100%;\r\n        }\r\n}\r\n\r\n/** Media queries to set font size and spacing based on screen size **/\r\n\r\n/*#region Small Screens*/\r\n\r\n  /* Styles for screens smaller than 800px wide or 550 high */\r\n  @media (max-width: 800px) or (max-height: 550px) {\r\n\r\n    .pilot-table-title {\r\n        font-size: var(--font-size-large);\r\n    }\r\n\r\n    .table-chip-label {\r\n        display: none;\r\n    }\r\n\r\n    .table-chip-icon {\r\n        margin: 0;\r\n        height: 80%;\r\n        width: 80%;\r\n    }\r\n\r\n  }\r\n/*#endregion Small Screens*/\r\n\r\n/*#region Medium Screens*/\r\n\r\n  /* Styles for medium screens with min with of 800px and min height of 550px */\r\n  @media (min-width: 800px) and (min-height: 550px) {\r\n\r\n    .pilot-table-title {\r\n        font-size: var(--font-size-large);\r\n    }\r\n\r\n  }\r\n\r\n/*#endregion Medium Screens*/\r\n\r\n/*#region Larger Screens*/\r\n\r\n  /* Styles for screens larger than 1000px wide and 600px high */\r\n  @media (min-width: 1000px) and (min-height: 600px) {\r\n\r\n    .pilot-table-title {\r\n        font-size: var(--font-size-large);\r\n    }\r\n\r\n  }\r\n\r\n/*#endregion Larger Screens*/\r\n","// =============================================================================\r\n//  accord-breakpoints.scss\r\n//\r\n//  Standard 3-tier Responsive Breakpoints for the Accord Design System.\r\n//  Based on Google Material Design 3 guidelines.\r\n//\r\n//  Breakpoints:\r\n//    Mobile  — max-width: 599px\r\n//    Tablet  — min-width: 600px and max-width: 1023px\r\n//    Desktop — min-width: 1024px\r\n//\r\n//  Usage in component SCSS (with @use):\r\n//    @use 'src/theme/mocca-breakpoints' as bp;\r\n//    @include bp.mobile  { ... }\r\n//    @include bp.tablet  { ... }\r\n//    @include bp.desktop { ... }\r\n//\r\n//  Or via raw @media (legacy/global):\r\n//    @media (max-width: 599px)                        { ... }  // mobile\r\n//    @media (min-width: 600px) and (max-width: 1023px){ ... }  // tablet\r\n//    @media (min-width: 1024px)                       { ... }  // desktop\r\n// =============================================================================\r\n\r\n/// Mobile only — screens ≤ 599px\r\n@mixin mobile {\r\n  @media (max-width: 599px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Tablet only — screens 600px–1023px\r\n@mixin tablet {\r\n  @media (min-width: 600px) and (max-width: 1023px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Desktop and above — screens ≥ 1024px\r\n@mixin desktop {\r\n  @media (min-width: 1024px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Tablet and above — screens ≥ 600px (tablet + desktop)\r\n@mixin tablet-up {\r\n  @media (min-width: 600px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Desktop and below — screens ≤ 1023px (mobile + tablet)\r\n@mixin desktop-down {\r\n  @media (max-width: 1023px) {\r\n    @content;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
